(function (aimi_mdcdot_sequencer, $, app) {
  class DurationCalculator {
    static addDurations(durations, singular = false) {
      let totalDays = 0, totalHours = 0, totalMinutes = 0;

      durations.forEach(duration => {
        let parts = duration.match(/(\d+)\s*(day|hour|minute)s?/gi);
        if (parts) {
          parts.forEach(part => {
            let [_, num, unit] = part.match(/(\d+)\s*(day|hour|minute)s?/i);
            if (unit.startsWith("day")) totalDays += parseInt(num);
            if (unit.startsWith("hour")) totalHours += parseInt(num);
            if (unit.startsWith("minute")) totalMinutes += parseInt(num);
          });
        }
      });

      // Normalize time
      totalHours += Math.floor(totalMinutes / 60);
      totalMinutes = totalMinutes % 60;
      totalDays += Math.floor(totalHours / 24);
      totalHours = totalHours % 24;

      return DurationCalculator.formatDuration(totalDays, totalHours, totalMinutes, singular);
    }

    static subtractDurations(baseDuration, durations) {
      let totalMinutes = DurationCalculator.toMinutes(baseDuration);

      durations.forEach(duration => {
        totalMinutes -= DurationCalculator.toMinutes(duration);
      });

      if (totalMinutes < 0) return "0 minutes"; // Prevent negative time

      let totalDays = Math.floor(totalMinutes / 1440);
      totalMinutes %= 1440;
      let totalHours = Math.floor(totalMinutes / 60);
      totalMinutes %= 60;

      return DurationCalculator.formatDuration(totalDays, totalHours, totalMinutes);
    }

    static toMinutes(duration) {
      let totalMinutes = 0;
      let parts = duration.match(/(\d+)\s*(day|hour|minute)s?/gi);
      if (parts) {
        parts.forEach(part => {
          let [_, num, unit] = part.match(/(\d+)\s*(day|hour|minute)s?/i);
          if (unit.startsWith("day")) totalMinutes += parseInt(num) * 1440;
          if (unit.startsWith("hour")) totalMinutes += parseInt(num) * 60;
          if (unit.startsWith("minute")) totalMinutes += parseInt(num);
        });
      }
      return totalMinutes;
    }

    static formatDuration(days, hours, minutes, singular = false) {
      let result = [];
      if (days > 0) result.push(`${days} day${singular ? '' : days > 1 ? 's' : ''}`);
      if (hours > 0) result.push(`${hours} hour${singular ? '' : hours > 1 ? 's' : ''}`);
      if (minutes > 0) result.push(`${minutes} minute${singular ? '' : minutes > 1 ? 's' : ''}`);
      return result.join(' ') || "none";
    }
  }

  class Sequencer {
    constructor($element) {
      this.$element = $element;
      this.$ul = $('<ul></ul>');
      this.templates = this.initTemplates();
    }

    initTemplates() {
      return {
        nodeTemplate: _.template(app.templates['dot_sequencer__dot-node']),
        endTemplate: _.template(app.templates['dot_sequencer__end-action']),
        detailTemplate: _.template('<div class="img-circle"><%= label %></div>')
      };
    }

    static collectActionsData($tree) {
      let actions = [];
      let prevDurations = [];

      $tree.find(`[data-dot]`).each(function (i, dot) {
        const $dot = $(dot);
        if ($dot.is('[data-dot]') && !app.isEmpty($dot.attr('data-dot'))) {
          const id = $dot.find(`.node-label [data-id]`).attr('data-id').split('-');
          const duration = $dot.find(`[data-duration]`).attr('data-duration');
          let dotData = {};

          // Check if it has a parent with data-activities
          if (!$dot.is('[data-activities]')) {
            prevDurations.push(duration);
            dotData[id[0]] = {
              id: id[1],
              delay: DurationCalculator.addDurations(prevDurations)
            }
            actions.push(dotData);
          }

        }
      });

      return actions;
    }


    static collectData() {
      const requestData = {
        "id": app.sequencerSequenceId,
        "defaultActions": [],
        "qualifierActions": [],
        "nonQualifierActions": [],
        "qualifyingParams": [],
        "nonQualifyingParams": [],
      };

      let prevDurations = [];
      const $tree = $('.sequence-tree');
      $tree.find(`[data-dot]`).each(function (i, dot) {
        if (i > 1) {
          const $dot = $(dot);
          if ($dot.is('[data-dot]') && !app.isEmpty($dot.attr('data-dot'))) {

            const id = $dot.find(`.node-label [data-id]`).attr('data-id').split('-');
            const duration = $dot.find(`[data-duration]`).attr('data-duration');
            let dotData = {};

            if ($dot.is('[data-activities]') && !app.isEmpty($dot.attr('data-activities'))) {
              let activities = $dot.attr('data-activities');
              let url = $dot.attr('data-url');
              const branchType = activities.includes("DidNot") ? 'DidNot' : 'Did';
              activities = activities.split(',').map(activity => activity.trim());
              const qualifierDot = Utils.capitalizeFirstLetter(id[0].replace('Send', ''));
              let activitiesData = [];
              const expires = DurationCalculator.addDurations([...prevDurations, ...[duration]], true);
              activities.forEach(function (activity) {
                dotData = {
                  "url": url,
                  "expires": expires,
                  "activity": activity,
                  "id": id[1],
                  "type": id[0],
                  "delay": expires
                }
                activitiesData.push(dotData);
              });

              let qualifyNonQualify = {};
              qualifyNonQualify[qualifierDot] = activitiesData;

              if (branchType === 'Did') {
                requestData.qualifyingParams.push(qualifyNonQualify);
              }

              if (branchType === 'DidNot') {
                requestData.nonQualifyingParams.push(qualifyNonQualify);
              }

            } else {
              // console.log($dot, $dot.closest('ul'), $dot.closest('ul').siblings(`div[data-dot]`), $dot.closest('ul').siblings(`div[data-dot]`).is('[data-activities]'));
              // Check if it has a parent with data-activities
              if ($dot.closest('[data-id^="nq-"]').length > 0 || $dot.closest('[data-id^="q-"]').length > 0) {

              } else {
                prevDurations.push(duration);
                dotData[id[0]] = {
                  id: id[1],
                  delay: DurationCalculator.addDurations(prevDurations)
                }
                requestData.defaultActions.push(dotData);
              }

            }
          }
        }
      });

      if ($tree.find('[data-activities]').length > 0) {
        const $branches = $tree.find('[data-dot][data-activities]');
        _.each($branches, function (branch) {
          const $branch = $(branch);

          let activities = $branch.attr('data-activities');
          const branchType = activities.includes("DidNot") ? 'DidNot' : 'Did';
          const $parent = $branch.closest(`li`);


          if (branchType === 'Did') {
            requestData.qualifierActions = Sequencer.collectActionsData($parent);
          }

          if (branchType === 'DidNot') {
            requestData.nonQualifierActions = Sequencer.collectActionsData($parent);
          }
        })
      }

      return requestData;
    }

    static removeContextMenu() {
      // Displays a context menu for adding new actions
      $(".dot-context-menu").remove();
    }

    static getActions() {
      let actions = ['email-variants', 'email'];
      const count = $('.sequence-tree').find('ul').length;
      if (count === 4) {
        actions.push('add-branches');
      }
      if (count >= 4) {
        actions.push('add-to-group');
      }
      return actions;
    }

    static removeDeleteActions($tree) {
      $tree.find('.btn-dot-delete').remove();
    }

    static addEndActions($tree) {

      // Get and add end nodes unless the type is 'QualifyNonQualify'
      const endNodes = Sequencer.getEndNode();

      if ($tree.find('[data-activities]').length > 0) {
        const $branches = $tree.find('[data-dot][data-activities]');
        _.each($branches, function (branch) {
          const $parent = $(branch).closest(`li`);
          if ($parent.length) {
            $parent.addNodes(endNodes);
          }
        })
      } else {
        const $lastUl = $tree.find('ul').last();
        const $firstLi = $lastUl.find('li').eq(0);
        $firstLi.addNodes(endNodes);
      }
    }

    static getEndNodeActionDom() {
      // Ensure `app.addNewActionButton` exists and is a valid jQuery object
      if (!app.addNewActionButton || !app.addNewActionButton.length) {
        console.error("addNewActionButton is not defined or not found.");
        return null;
      }

      // Find the closest `.dot-node` element
      const $node = app.addNewActionButton.closest(".dot-node");
      if (!$node.length) {
        console.error("No .dot-node found.");
        return null;
      }

      // Find and return the closest `ul` element
      const $ul = $node.closest("ul");
      if (!$ul.length) {
        console.error("No <ul> element found near .dot-node.");
        return null;
      }

      return $ul;
    }

    static getEndNode() {
      let data = [{
        "id": null,
        "dotKey": null,
        "label": "End",
        "subLabel": null,
        "duration": null,
        "addAction": true,
        "icon": "<i class='fa fa-flag'></i>",
        "campaignStart": false,
        "campaignEnd": true,
        "sequenceStart": false
      }];

      return data;

    }

    static getEmailNode(emailId) {
      const email = app.allEmails[emailId];
      const id = app.generateId();
      let data = [
        {
          "id": `da-${id}`,
          "dotKey": `SendEmail-${email.id}`,
          "label": "Send Email",
          "subLabel": email.name,
          "duration": "1 day",
          "durationText": "1 day",
          "addAction": null,
          "icon": "<i class='fa fa-envelope'></i>",
          "campaignStart": false,
          "campaignEnd": false,
          "sequenceStart": false,
        }
      ];
      return data;
    }

    static getEmailVariantNode(emailVariantId) {
      const id = app.generateId();
      const emailVariant = app.allEmailVariants[emailVariantId];

      let data = [
        {
          "id": `da-${id}`,
          "dotKey": `SendVariant-${emailVariantId}`,
          "label": "Send Email Variants",
          "subLabel": emailVariant.name,
          "duration": "1 day",
          "durationText": "1 day",
          "addAction": null,
          "icon": "<i class='fa fa-envelope-open-text'></i>",
          "campaignStart": false,
          "campaignEnd": false,
          "sequenceStart": false,
        }
      ];
      return data;
    }

    static getGroupNode(groupId) {
      const group = app.allDotGroups[groupId];
      const id = app.generateId();
      let data = [
        {
          "id": `g-${id}`,
          "dotKey": `Group-${group.id}`,
          "label": "Group",
          "subLabel": group.name,
          "duration": "2 day",
          "durationText": "2 day",
          "addAction": null,
          "icon": "<i class='fa fa-envelope'></i>",
          "campaignStart": false,
          "campaignEnd": false,
          "sequenceStart": false
        }
      ];
      return data;
    }

    static getBranchNodes(parentData) {

      const nqid = app.generateId();
      const qid = app.generateId();
      const parentDot = parentData.dot.split('-');
      const dotType = parentDot[0];
      const dotId = parentDot[1];
      let email;

      if (dotType === 'SendEmail') {
        email = app.allEmails[dotId];
      }
      if (dotType === 'SendVariant') {
        email = app.allEmailVariants[dotId];
      }


      let data = [
        {
          "id": `nq-${nqid}`,
          "dotKey": `${dotType}-${email.id}`,
          "label": "Did Not Open",
          "activities": ["DidNotOpen"],
          "subLabel": email.name,
          "duration": "1 day",
          "durationText": "1 day",
          "addAction": null,
          "icon": "<i class='fa fa-thumbs-down text-danger'></i>",
          "campaignStart": false,
          "campaignEnd": false,
          "sequenceStart": false
        },
        {
          "id": `q-${qid}`,
          "dotKey": `${dotType}-${email.id}`,
          "label": "Did Click, Did Open",
          "activities": ["DidClick, DidOpen"],
          "subLabel": email.name,
          "duration": "1 day",
          "durationText": "1 day",
          "addAction": null,
          "icon": "<i class='fa fa-thumbs-up text-primary'></i>",
          "campaignStart": false,
          "campaignEnd": false,
          "sequenceStart": false
        }
      ];

      return data;

    }

    static getEndActionTemplate() {
      let endNode = _.template(app.templates["dot_sequencer__end-action"])();
      return endNode;
    }

    generateNodeElement(node) {
      let status;
      if (!app.isEmpty(app.sequenceTreeSequence)) {
        status = app.sequenceTreeSequence.status;
      }
      let sequenceView = 'campaign';
      if (!app.isEmpty(app.sequencerSequenceId)) {
        sequenceView = 'sequence';
      }
      const nodeData = {
        sequenceView: sequenceView,
        id: '',
        status: status, ...node, ...{endActions: Sequencer.getEndActionTemplate()}
      };
      return $(this.templates.nodeTemplate(nodeData));
    }

    getStatus(node) {
      return node.cancelled ? ' (Cancelled)' : node.inactive ? ' (Inactive)' : '';
    }

    getUserImage(node) {
      return node.cancelled ? '<i class="fa fa-close"></i>' : '<i class="fa fa-user"></i>';
    }

    addPopover($node, node) {
      if ($node.length) {
        const detailContent = this.templates.detailTemplate({userImage: '<i class="fa fa-user"></i>', ...node});
        try {
          $node.popover({
            html: true,
            content: detailContent,
            placement: 'auto',
            trigger: 'hover focus',
            container: 'body'
          });
        } catch (error) {
          console.error('Popover initialization failed:', error);
        }
      } else {
        console.error('Node not found:', $node);
      }
    }

    createNode(node) {
      const $nodeElement = this.generateNodeElement(node);
      if (!_.isEmpty(node)) {
        //this.addPopover($nodeElement, node);
      }
      return $('<li></li>').attr('data-id', node.id).append($nodeElement);
    }

    addNodes(nodes) {
      nodes.forEach(function (node) {
        if (!Array.isArray(node)) {
          // If the node is not an array, create and append it to the current $ul
          this.createNode(node).appendTo(this.$ul);
        } else {
          // If the node is an array, create a new <ul> and process its elements
          const newUl = $('<ul></ul>');
          this.$ul.append(newUl); // Append the new <ul> to the current <ul>

          // Temporarily set the context to the new <ul>
          const previousUl = this.$ul; // Store the current $ul context
          this.$ul = newUl;
          this.addNodes(node); // Recursively process the array
          this.$ul = previousUl; // Restore the previous $ul context
        }
      }.bind(this));

      // Append the current $ul to the element only if it contains nodes
      if (this.$ul.children().length > 0) {
        this.$element.append(this.$ul);
      }

      return this.$ul;
    }

  }

  $.fn.addNodes = function (nodes) {
    const tree = new Sequencer($(this));
    return tree.addNodes(nodes);
  };

  $.fn.sequenceTree = function (data, clean = false, render = true, sequence) {
    const $this = $(this);
    app.sequenceTreeSequence = sequence;

    if (clean) {
      $this.empty();
    }
    const $sequenceTree = $('<div>').addClass('sequence-tree');
    _.each(data, (nodes, parent) => {
      const parentId = parent.indexOf('p-') >= 0 ? parent.replace('p-', '') : parent;
      const $parentNode = $sequenceTree.find(`li[data-id="${parentId}"]`);
      if ($parentNode.length) {
        $parentNode.addNodes(nodes);
      } else {
        $sequenceTree.addNodes(nodes);
      }
    });

    if (render) {
      $this.append($sequenceTree);
    }


    return $sequenceTree;
  };

  function calculateMargin($element, containerWidth) {
    // Simplified margin calculation function
    let marginLeft = 0;
    const parentWidth = $element.parent().width();
    marginLeft = parentWidth < containerWidth ? parentWidth / 2 : 0;
    return marginLeft;
  }

  const genealogy = (() => ({
    setWidth() {
      const containerWidth = $('.sequence-tree--container').width();
      $('style[data-genealogy]').remove();
      $('.sequence-tree').each(function () {
        const $this = $(this);
        const parentDataId = $this.parent().attr('data-id');
        const marginLeft = calculateMargin($this, containerWidth);

        if (parentDataId) {
          $('head').append(`
            <style data-genealogy data-id="${parentDataId}">
              li[data-id="${parentDataId}"] { padding-top: 180px; }
              li[data-id="${parentDataId}"]:before { height: 180px; }
              li[data-id="${parentDataId}"] > .sequence-tree:after { height: 20px; width: calc(50% - ${marginLeft}px); }
            </style>
          `);
        }
      });
    }
  }))();

  const observeEmailModalResize = function ($modal) {
    function debounce(callback, delay) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => callback(...args), delay);
      };
    }

    const debouncedCallback = debounce(() => {
      let width = $modal.find('.modal-body').width();
      //width -= 200;
      app.cssVar('calendar-card-width', width);

    }, 100);

    const observeResize = new ResizeObserver(entries => {
      debouncedCallback();
    });

    observeResize.observe($modal.find('.modal-body')[0]);
  }

  const addNewNode = function (type, responseData) {
    const $root = $(".sequence-tree");
    // Get the end action element and the initial tree node
    let $endActionEl = Sequencer.getEndNodeActionDom();
    let $tree = null; // Initialize $tree to ensure it's defined

    if ($endActionEl && $endActionEl.length > 0) {
      $tree = $endActionEl.closest('li');
    }

    // Fallback to the closest sequence tree if $tree is not found
    if (!$tree || $tree.length === 0) {
      $tree = $root;
    }

    console.log("Here", $tree);

    let nodes;

    switch (type) {
      case 'SendEmail':
        nodes = Sequencer.getEmailNode(responseData.SendEmail);
        break;

      case 'SendVariant':
        nodes = Sequencer.getEmailVariantNode(responseData.SendVariant);
        break;

      case 'Group':
        nodes = Sequencer.getGroupNode(responseData.Group);
        break;

      case 'QualifyNonQualify':
        nodes = Sequencer.getBranchNodes($tree.find('[data-dot]').data());
        break;

      case 'end':
        nodes = [];
        const ul = app.dotDeleteButton.closest('ul');
        ul.nextAll().addBack().remove();
        ul.appendTo(ul.parent().find('li'));
        break;

      default:
        console.error(`Unknown type: ${type}`);
        return;
    }

    // Add the main nodes if any
    if (nodes && nodes.length) {
      const $addedNode = $tree.addNodes(nodes);
    }

    // Remove the end action element
    if ($endActionEl && $endActionEl.length > 0) {
      $endActionEl.remove();
    }

    // Get and add end nodes unless the type is 'QualifyNonQualify'
    const endNodes = Sequencer.getEndNode();

    if (nodes && nodes.length) {
      // Special handling for 'QualifyNonQualify' type
      nodes.forEach(function (node) {
        const id = node.id;
        const $parent = $tree.find(`li[data-id=${id}]`);
        if ($parent.length) {
          $parent.addNodes(endNodes);
        }
      });
    } else {
      $tree.addNodes(endNodes);
    }


    if (type !== 'QualifyNonQualify') {
      if (endNodes && endNodes.length) {
        // $parent.addNodes(endNodes);
      }
    } else {

    }
  };

  aimi_mdcdot_sequencer.newEmailTemplatePayloadProcessor = function (requestData) {
    requestData.type = 'user';
    console.log(requestData);
    return requestData;
  }

  aimi_mdcdot_sequencer.newEmailTemplateSaveCallback = async function (response) {
    // Display a notification with the response message and set the progress to 90%
    if (!app.isEmpty(app.notifyEl)) {
      app.notifyEl.update({'message': response.message, progress: 90});
    }

    // Identify and hide the modal window associated with the update action
    const $modal = response.$button.closest('.modal');
    const $select = await renderEmailsListDropdown(app.dotInfoModal, response.email.id, true);
    $select.trigger('change');

    app.hideModal($modal);

  }


  aimi_mdcdot_sequencer.emailPayloadProcessor = function (requestData) {

    let currentDot = app.currentOpenDot;

    if (!app.isEmpty(currentDot.dot) && currentDot.dot.length) {
      const $dot = currentDot.dot.find(`[data-id="${currentDot['data-id']}"]`);
      const $subLabel = $dot.find(`[data-node-sub-label]`);
      const newId = requestData.SendEmail;
      let existingId = $dot.attr('data-id').split('-');
      existingId[1] = newId;
      const newFullId = existingId.join('-');

      const email = app.allEmails[newId];
      $dot.attr('data-id', newFullId);
      $subLabel.html(email.name);
    } else {
      addNewNode('SendEmail', requestData);
    }

    return Sequencer.collectData();
  }


  aimi_mdcdot_sequencer.dotGroupPayloadProcessor = function (requestData) {
    let currentDot = app.currentOpenDot;

    if (!app.isEmpty(currentDot.dot) && currentDot.dot.length) {
      const $dot = currentDot.dot.find(`[data-id="${currentDot['data-id']}"]`);
      const $subLabel = $dot.find(`[data-node-sub-label]`);
      const newId = requestData.Group;
      let existingId = $dot.attr('data-id').split('-');
      existingId[1] = newId;
      const newFullId = existingId.join('-');

      const group = app.allDotGroups[newId];
      console.log(group);
      $dot.attr('data-id', newFullId);
      $subLabel.html(group.name);
    } else {
      addNewNode('Group', requestData);
    }

    return Sequencer.collectData();
  }

  aimi_mdcdot_sequencer.QualifyNonQualifyPayloadProcessor = function (requestData) {
    let currentDot = app.currentOpenDot;

    if (!app.isEmpty(currentDot.dot) && currentDot.dot.length) {
      const activities = requestData.activity.join(',');
      const $dot = currentDot.dot.find(`[data-id="${currentDot['data-id']}"]`);
      $dot.attr('data-activities', activities);
      currentDot.dot.attr('data-activities', activities);
      currentDot.dot.attr('data-url', requestData.url);
      const $label = $dot.find(`[data-node-label]`);
      let labelData = [];
      requestData.activity.forEach(val => {
        labelData.push(Utils.addSpaces(val));  // Logs "Did Visit", "Did Click", etc.
      });

      $label.html(labelData.join(', '));
    }

    return Sequencer.collectData();
  }

  aimi_mdcdot_sequencer.emailVariantPayloadProcessor = function (requestData) {
    let currentDot = app.currentOpenDot;

    if (!app.isEmpty(currentDot.dot) && currentDot.dot.length) {
      const $dot = currentDot.dot.find(`[data-id="${currentDot['data-id']}"]`);
      const $subLabel = $dot.find(`[data-node-sub-label]`);
      const newId = requestData.SendVariant;
      let existingId = $dot.attr('data-id').split('-');
      existingId[1] = newId;
      const newFullId = existingId.join('-');

      const email = app.allEmailVariants[newId];
      $dot.attr('data-id', newFullId);
      $subLabel.html(email.name);
    } else {
      addNewNode('SendVariant', requestData);
    }

    return Sequencer.collectData();
  }

  aimi_mdcdot_sequencer.durationPayloadProcessor = function (requestData) {
    let currentDot = app.currentOpenDot;

    if (!app.isEmpty(currentDot.dot) && currentDot.dot.length) {
      let text = 'asap';
      if (requestData.delay === 'delay') {
        text = `${requestData.durationTime} ${requestData.durationUnit}`;
      }
      const $dot = currentDot.dot.find(`[data-id="${currentDot['data-id']}"]`);
      const $textNode = $dot.find(`[data-node-text]`);
      if ($dot.is('[data-duration]')) {
        $dot.attr('data-duration', text);
      }
      $textNode.html(text);
    }

    return Sequencer.collectData();
  }

  aimi_mdcdot_sequencer.QualifyNonQualifySaveCallBack = function (response) {
    // Display a notification with the response message and set the progress to 90%
    if (!app.isEmpty(app.notifyEl)) {
      app.notifyEl.update({'message': response.message, progress: 90});
    }

    // Identify and hide the modal window associated with the update action
    const $modal = response.$button.closest('.modal');
    app.hideModal($modal);
  }

  aimi_mdcdot_sequencer.durationSaveCallBack = function (response) {
    // Display a notification with the response message and set the progress to 90%
    if (!app.isEmpty(app.notifyEl)) {
      app.notifyEl.update({'message': response.message, progress: 90});
    }

    // Identify and hide the modal window associated with the update action
    const $modal = response.$button.closest('.modal');
    app.hideModal($modal);

  }

  aimi_mdcdot_sequencer.emailSaveCallBack = async function (response) {
    // Display a notification with the response message and set the progress to 90%
    if (!app.isEmpty(app.notifyEl)) {
      app.notifyEl.update({'message': response.message, progress: 90});
    }

    // Identify and hide the modal window associated with the update action
    const $modal = response.$button.closest('.modal');
    app.hideModal($modal);

    const responseData = response.payloadData;

  };

  aimi_mdcdot_sequencer.dotGroupSaveCallBack = async function (response) {
    // Display a notification with the response message and set the progress to 90%
    if (!app.isEmpty(app.notifyEl)) {
      app.notifyEl.update({'message': response.message, progress: 90});
    }

    // Identify and hide the modal window associated with the update action
    const $modal = response.$button.closest('.modal');
    app.hideModal($modal);

    const responseData = response.payloadData;

  };

  aimi_mdcdot_sequencer.emailVariantSaveCallBack = async function (response) {
    // Display a notification with the response message and set the progress to 90%
    if (!app.isEmpty(app.notifyEl)) {
      app.notifyEl.update({'message': response.message, progress: 90});
    }

    // Identify and hide the modal window associated with the update action
    const $modal = response.$button.closest('.modal');
    app.hideModal($modal);

    const responseData = response.payloadData;

  };


  aimi_mdcdot_sequencer.createPayloadProcessor = function (requestData) {
    requestData.campaign = app.sequencerCampaignId;
    requestData.campaignId = app.sequencerCampaignId;
    requestData.public = requestData.public === "true";
    requestData.campaignStart = "uponLaunch";

    if (requestData['filters'] === 'Group') {
      requestData.filters = {'Group': {'id': requestData.dotGroup}};
      delete requestData.dotGroup;
    }

    return requestData;
  }

  aimi_mdcdot_sequencer.createCallBack = async function (response) {
    // Display a notification with the response message and set the progress to 90%
    app.notifyEl.update({'message': response.message, progress: 90});

    // Identify and hide the modal window associated with the update action
    const $modal = response.$button.closest('.modal');
    app.hideModal($modal);

    app.redirect(`/email/campaign/${app.sequencerCampaignId}/${response.sequence.id}`);
  };

  const getSaveButtonText = function (id) {
    let saveButtonText;

    if (app.isEmpty(id)) {
      saveButtonText = "Add to Sequence";
    } else {
      saveButtonText = "Update Sequence";
    }

    if (app.isEmpty(app.sequencerSequenceId) || app.firstSequence.status !== 'pending') {
      saveButtonText = false;
    }

    return saveButtonText;
  }

  const openEmailVariantsEditor = async function (id = null) {
    const saveButtonText = getSaveButtonText(id);

    try {

      const $modal = app.infoModal(".", "", {
        id: "emailVariantsEditor",
        headerHtml: `<div class="pg-header-wth-tab position-absolute start-0">
                            <ul class="nav nav-tabs nav-line nav-icon nav-light header-tabs-start"></ul>
                          </div>`,
        saveButton: saveButtonText ? 'd-inline-flex' : 'd-none',
        saveButtonText: saveButtonText,
        footerText: '<span class="fw-semibold text-primary ms-40">Note:  </span><span>Select "Create New Email Variant" from above dropdown to create a new email variant</span>',
        dialogClass: "modal-dialog-scrollable modal-full modal-email-variants-editor",
      });

      app.emailVariantsModal = $modal;
      $('.btn-confirm', $modal).off('click').on('click', function (e) {
        const $form = $modal.find('form[name=emailvariant-form]');
        let form;
        const event = new Event('submit', {
          bubbles: true,    // The event will bubble up through the DOM
          cancelable: true  // The event can be canceled
        });

        let nextStepForm = aimi_email_variants.view.navigateToNextStep();
        console.log(nextStepForm);
        if (nextStepForm) {
          console.log(nextStepForm, nextStepForm.find('button[type=submit]'));
        } else {
          form = $form.eq(0)[0];
          if (form.checkValidity()) {
            $modal.modal('hide');
          }

          if (!app.isEmpty(form)) {
            form.dispatchEvent(event);
          }
        }
      })


      const progress = new ProgressBar($modal.find(".modal-body"));
      progress.start();

      await aimi_email_variants.view.init(id, "[data-email-variants-view-root]", ".modal-email-variants-editor");

      setTimeout(async function () {
        progress.remove();
      }, 2000)


    } catch (error) {
      console.error("Error loading email variants:", error);
    }
  }

  const openEmailVariantsTable = function ($this) {
    // Handles modals for dot info, group addition, or email configuration
    const aimiEmailCampaignId = $this.attr("data-id").split("-")[1]; // Extract identifier from the `data-id` attribute
    let modalTitle = $this.attr('data-sublabel');
    if (!app.isEmpty(modalTitle)) {
      modalTitle = `${modalTitle}: Stats`;
    } else {
      modalTitle = '';
    }
    // Open a modal for campaign leads
    const $leadModal = app.infoModal(`Email Variant #${aimiEmailCampaignId} ${modalTitle} `, '', {
      id: 'emailVariantStatsModal',
      dialogClass: 'modal-dialog-scrollable modal-full modal-email-variant-stats-modal'
    });

    const $leadModalBody = $('.modal-body', $leadModal);

    // Render the leads template
    const emailTable = _.template(app.templates['dot_email__list']);
    const $emailTable = $(emailTable());
    $emailTable.appendTo($leadModalBody);

    aimi_mdcdot_email_variant.list.init('.email-variants-container', aimiEmailCampaignId);
  }

  const renderEmailsListDropdown = async function ($modal, idInfo, fetch = false) {
    if (fetch) {
      const apiResponse = await app.apis['mdcdot_email'].list();
      // Get all emails data
      app.allEmails = apiResponse.emails;
    }

    const $select = $modal.find('select[name="SendEmail"]'); // Find email dropdown
    const emailsDropdown = new DropdownUtility($select);

    // Populate dropdown with all email data
    emailsDropdown.populateDropdown(_.values(app.allEmails), "id", "name", "Select an email");

    const options = $select.find('option');

    options.filter(`[value="${idInfo}"]`).prop('selected', true);

    return $select;
  }

  aimi_mdcdot_sequencer.helpers = {
    showEmailPreview: function (id) {
      // Show email preview modal with a loading indicator
      const $modal = app.infoModal(
          "Email Preview",
          `<iframe frameborder="0" class="email-preview" src="/api/mdcdot/lead/0/email/${id}"></iframe>`,
          {dialogClass: "modal-lg modal-dialog-scrollable modal-email-preview"}
      );

      const progress = new ProgressBar($modal.find(".modal-body"));
      progress.start();

      const objectElement = document.querySelector(".email-preview");
      objectElement.onload = function () {
        progress.remove();
        objectElement.classList.add("loaded");
      };
    }
  }

  aimi_mdcdot_sequencer.init = async function (campaignId, sequenceId) {
    app.sequencerSequenceId = sequenceId;
    app.sequencerCampaignId = campaignId;

    app.initTooltip();

    // Instantiate the HorizontalScroller with your selectors
    const scroller = new HorizontalScroller(
        '.sequencer-tabs-wrapper',        // Wrapper selecto
    );

    $('.input-spinner-wrap input').inputSpinner({buttonsOnly: true}).on('change', function () {
      const zoomContainer = $('.sequence-tree--container')[0];
      zoomContainer.style.transform = `scale(${this.value / 100})`;
    });

    $('.btn-flip-horizontal').on('click', function () {
      $('.zoom-container').toggleClass('vertical horizontal');
    });

    // Hide context menu when clicking outside
    $(document).on('click', function (event) {
      if (!$(event.target).closest('.btn-add-new-sequence-action, .dot-context-menu').length) {
        $('.dot-context-menu').hide();
      }
    });

    const container = $('.sequence-tree--container');
    const $sequenceActions = $('.sequence-actions');
    container.sequenceTree(loaderData);

    $(document).on("click.sequencer-actions", "[data-sequence-action]", async function (e) {
      const app = PreBuilt;
      const $this = $(this);
      const action = $this.attr("data-sequence-action");
      const checkbox = _.template(app.templates['global__checkbox-switch']);

      // Prevent multiple event triggers
      e.stopImmediatePropagation();
      e.stopPropagation();

      /**
       * Switch-case to handle different `data-sequence-action` values.
       */
      switch (action) {
        case "dot-email-preview":
          // Handles the email preview modal
          const dataId = $this.attr("data-id");
          const id = dataId.split("-")[1];

          if ($this.attr("data-id").includes("SendEmail") && !$this.attr("data-id").includes("SendVariant")) {
            console.log("ID:", id); // Example: ID: 99

            aimi_mdcdot_sequencer.helpers.showEmailPreview(id);

          } else if ($this.attr("data-id").includes("SendVariant")) {

          } else {
            console.log("Pattern not matched.");
            return false;
          }
          break;

        case "dot-duration":
          app.currentOpenDot = {
            'dot': $this.closest('[data-dot]:not(.campaign-end)'),
            'data-id': $this.attr('data-id')
          };

          const switchAsap = checkbox({
            'type': 'radio',
            'id': 'delay-asap',
            'name': 'delay',
            'value': 'asap',
            'label': '(ASAP) Upon Contact Qualifying '
          });

          const switchDelay = checkbox({
            'type': 'radio',
            'id': 'delay-add',
            'name': 'delay',
            'value': 'delay',
            'label': 'Add Delay',
            'collapse': '#delayCollapse'
          });

          // Handles modals for dot info, group addition, or email configuration
          const duration = $this.attr("data-duration").split(" ").map(t => t.trim());

          // Determine the save button text based on whether `idInfo` is empty
          let durationSaveButtonText = "Update Sequence";

          if (app.isEmpty(app.sequencerSequenceId) || app.firstSequence.status !== 'pending') {
            durationSaveButtonText = false;
            return false;
          }

          // Opens a modal to configure the delay from sequence start
          app.inputPrompt({
            data: {switchAsap: switchAsap, switchDelay: switchDelay},
            type: "input",
            modalDialogClass: "modal-lg modal-dialog-centered modal-dialog-scrollable modal-dot-duration",
            template: "dot_sequencer__duration",
            title: "Delay from previous action",
            saveButtonText: durationSaveButtonText,
            footerText: '<span class="fw-semibold text-primary">Note: Add Delay for next action </span>',
            saveApi: 'mdcdot_sequence.save',
            payloadProcessor: 'aimi_mdcdot_sequencer.durationPayloadProcessor',
            saveApiCallBack: 'aimi_mdcdot_sequencer.durationSaveCallBack'
          }).then(function ($modal) {
            app.durationModal = $modal;
            app.initRadioSwitches($modal);

            const $durationTime = $modal.find(':input[name=durationTime]');
            const $durationUnit = $modal.find(':input[name=durationUnit]');
            const $switchDelay = $modal.find(':input[name=delay]');

            $switchDelay.on('change.modal', function () {
              const $this = $(this);
              const value = $this.val();
              if (value === 'delay') {
                $durationTime.attr('required', 'required');
                $durationUnit.attr('required', 'required');
              } else {
                $durationTime.removeAttr('required');
                $durationUnit.removeAttr('required');
              }
            })

            if (duration[0] === 'asap' || duration[0] === 'none') {
              $switchDelay.filter(`[value=asap]`).prop('checked', true);
            } else {
              $switchDelay.filter(`[value=delay]`).prop('checked', true);
              // Ensure the event listener is properly attached and then trigger the change
              setTimeout(() => {
                $switchDelay.trigger('click'); // Trigger the change event
                $switchDelay.triggerHandler('change'); // Trigger the change event
              }, 100);

              $durationTime.val(duration[0]);
              $durationUnit.val(duration[1]);
            }

          });

          break;

        case "dot-info":
        case "add-to-group":
        case "email":
        case "sequence-qualifier":
          app.currentOpenDot = {
            'dot': $this.closest('[data-dot]:not(.campaign-end)'),
            'data-id': $this.attr('data-id')
          };

          // Handles modals for dot info, group addition, or email configuration
          const idInfo = $this.attr("data-id").split("-")[1]; // Extract identifier from the `data-id` attribute
          let type, template, title, saveButtonText, data, emailHtml;

          // Define footer text, payload processor, and save callback for email and group templates
          let footerText, payloadProcessor, saveApiCallback;

          const activities = $this.attr('data-activities');

          // Determine type and corresponding template and title based on `data-id`
          if (!app.isEmpty(activities)) {
            type = "QualifyNonQualify";
            template = "dot_sequencer__dot-activity-listener";
            title = "Activity Settings";
            data = {'branchType': (activities.includes("DidNot") ? 'DidNot' : 'Did')};
            data.activities = activities.split(',').map(activity => activity.trim());
            footerText = 'Allowed Actions : '
            footerText += data.branchType === 'DidNot' ? 'DidNotOpen, DidNotClick, DidNotVisit' : 'DidOpen, DidClick, DidVisit';
            const url = $this.attr('data-url');
            data.url = url;
            payloadProcessor = "aimi_mdcdot_sequencer.QualifyNonQualifyPayloadProcessor";
            saveApiCallback = "aimi_mdcdot_sequencer.QualifyNonQualifySaveCallBack";

          } else if ($this.attr("data-id").includes("SendEmail") && !$this.attr("data-id").includes("SendVariant")) {
            type = "SendEmail";
            template = "dot_sequencer__dot-email";
            title = "Email Settings";

            // Prepare email preview HTML
            emailHtml = app.isEmpty(idInfo)
                ? EmailVariantsList.createIframe({emailHtml: "Select an email to preview"}, true)
                : EmailVariantsList.createIframe({emailHtml: app.allEmails[idInfo]?.templateHtml});

            footerText = "Select an email from the dropdown";
            payloadProcessor = "aimi_mdcdot_sequencer.emailPayloadProcessor";
            saveApiCallback = "aimi_mdcdot_sequencer.emailSaveCallBack";
            data = {emailHtml: emailHtml}

          } else if ($this.attr("data-id").includes("SendVariant")) {
            type = "SendVariant";
          } else if ($this.attr("data-id").includes("Group")) {
            if (action === 'sequence-qualifier') {
              type = "Sequence Qualifier";
            } else {
              type = "Group";
              template = "dot_sequencer__dot-group";
              title = "Group Settings";
              footerText = "Create a new Dot Group or select an existing one";
              payloadProcessor = "aimi_mdcdot_sequencer.dotGroupPayloadProcessor";
              saveApiCallback = "aimi_mdcdot_sequencer.dotGroupSaveCallBack";
            }
          }

          if (app.isEmpty(app.sequencerSequenceId) && app.firstSequence.status === 'pending') {
            if (type === 'SendEmail') {
              return aimi_mdcdot_sequencer.helpers.showEmailPreview(idInfo);
            }
            if (type === 'SendVariant') {
              return openEmailVariantsTable($this);
            }
            return false;
          }

          if (app.firstSequence.status !== 'pending') {
            // Open a modal for campaign leads
            const $leadModal = app.infoModal(`${type} Leads `, '', {
              id: 'campaignLeadModal',
              dialogClass: 'modal-dialog-scrollable modal-full modal-campaign-leads-library'
            });

            const $leadModalBody = $('.modal-body', $leadModal);

            // Render the leads template
            const leadTemplate = _.template(app.templates['dot_campaign__leads']);
            const $leadTemplate = $(leadTemplate());
            $leadTemplate.appendTo($leadModalBody);

            // Set lead search parameters and initialize leads list
            if (type === 'Group' || type === 'Sequence Qualifier') {
              window['leadSearchParams'] = {...$this.data(), ...{'dotAction': 'dot-info', 'Group': idInfo}};
            } else if (type === 'SendVariant') {
              window['leadSearchParams'] = {...$this.data(), ...{'dotAction': 'dot-info', 'SendVariant': idInfo}};
            } else if (type === 'SendEmail') {
              window['leadSearchParams'] = {...$this.data(), ...{'dotAction': 'dot-info', 'SendEmail': idInfo}};
            } else {
              return false;
            }


            aimi_mdcdot_leads.list.init('.campaign-leads-container');
            return false;
          }

          // If the type is 'SendVariant', terminate execution (handled differently)
          if (type === "SendVariant") {
            await openEmailVariantsEditor(idInfo); // Open variant editor directly for `SendVariant`
            return false;
          }


          // Determine the save button text based on whether `idInfo` is empty
          saveButtonText = getSaveButtonText(idInfo);

          // Launch a modal for user input
          app.inputPrompt({
            data: data,
            type: "input",
            modalDialogClass: "modal-lg modal-dialog-centered modal-dialog-scrollable",
            template: template,
            title: title,
            saveButtonText: saveButtonText,
            footerText: `<span class="fw-semibold text-primary">Note: </span> <span>${footerText}</span>`,
            saveApi: "mdcdot_sequence.save",
            payloadProcessor: payloadProcessor,
            saveApiCallBack: saveApiCallback,
          }).then(async function ($modal) {
            app.dotInfoModal = $modal;

            // Handle specific configurations for the email template
            if (template === "dot_sequencer__dot-email") {
              observeEmailModalResize($modal); // Observe modal resizing
              const $select = await renderEmailsListDropdown($modal, idInfo);

              // Update email preview on dropdown selection change
              $select.on("change", function () {
                const emailPreview = $modal.find(".email-preview-container");
                const emailPreviewWrapper = emailPreview.find(".email-preview-wrapper");
                const editEmailButton = emailPreview.find('[data-sequence-action="show-edit-email-container"]');

                const idInfo = $(this).val();
                if (!app.isEmpty(idInfo)) {
                  editEmailButton.attr('data-id', idInfo);
                  emailHtml = EmailVariantsList.createIframe({emailHtml: app.allEmails[idInfo]?.templateHtml}, true);
                  emailPreviewWrapper.html(emailHtml);
                  emailPreview.removeClass('d-none');
                  app.observerManager = new ImageObserverManager(app, null, false);
                  let $iframes = $('[data-type="iframe"]', emailPreview);
                  $iframes.each(function (index, iframe) {
                    if ($(iframe).attr('data-src') !== '') {
                      app.observerManager.observeIntersection(iframe);
                    }
                  });
                } else {
                  emailPreview.addClass('d-none');
                }

              });


              $select.trigger('change');
            }

            // Handle specific configurations for the group template
            if (template === "dot_sequencer__dot-group") {
              const $dotGroup = app.dotInfoModal.find(':input[name=name]');
              // Remove 'is-invalid' on any key input
              $dotGroup.off('input.validation').on('input.validation', function () {
                const $this = $(this);
                if(app.isEmpty($this.val())) {
                  $this.addClass('is-invalid');
                } else {
                  $this.removeClass('is-invalid');
                }
              });

              const $select = await renderDotGroupDropdown(app.dotInfoModal); // Render group dropdown
              const options = $select.find('option');

              options.filter(`[value="${idInfo}"]`).prop('selected', true);
            }

            if (type === "QualifyNonQualify") {
              const $select = $modal.find('select[name="activity[]"]'); // Find  dropdown
              const $url = $modal.find(":input[name=url]");
              const options = $select.find('option');

              // Mark options as selected based on `data.activities`
              _.each(data.activities, function (activity) {
                options.filter(`[value="${activity}"]`).prop('selected', true);
              });

              if(!app.isEmpty(data.url)) {
                $url.removeClass('visually-hidden');
                $url.val(data.url);
              }

              $select.select2({
                placeholder: "",         // Set the placeholder to blank
                dropdownCssClass: 'tags-select2-dropdown',
                selectionCssClass: 'tags-select2-selection',
                tags: true,
                tokenSeparators: [',', ' ']
              })

              $select.on('change', function (e) {
                const selectedValues = $(this).val() || [];
                // Check if 'DidVisit' is currently selected
                if (selectedValues.includes('DidVisit')) {
                  $url.removeClass('visually-hidden');
                } else {
                  $url.addClass('visually-hidden');
                }
              });
            }
          });
          break;

        case 'add-new-group' :
          const $dotGroup = app.dotInfoModal.find(':input[name=name]');
          const dotGroupName = $dotGroup.val();

          // Validate on some action (e.g., form submit)
          if (app.isEmpty(dotGroupName)) {
            $dotGroup.addClass('is-invalid'); // Removed extra quote
            return false;
          } else {
            $dotGroup.removeClass('is-invalid');
          }

          app.doButtonAction($this);
          const dotGroup = await app.apis['mdcdot_campaign'].saveDotGroup({
            'name': dotGroupName,
          });

          const $select = await renderDotGroupDropdown(app.dotInfoModal);
          const options = $select.find('option');

          if (!app.isEmpty(dotGroup.dotGroup)) {
            options.filter(`[value="${dotGroup.dotGroup.id}"]`).prop('selected', true);
          } else {
            options.filter(function () {
              return $(this).text().trim() === dotGroupName;
            }).prop('selected', true);
          }

          app.doButtonResetDelayed($this, true);
          break;

        case 'show-new-email-container' :

          app.inputPrompt({
            data: {},
            modalId: "create-new-email",
            type: "input",
            formName: "create-new-email",
            modalDialogClass: "modal-xl modal-dialog-centered modal-dialog-scrollable modal-new-email",
            template: "dot_sequencer__dot-new-email",
            title: "Create New Email",
            saveButtonText: 'Save New Email',
            footerText: '<span class="fw-semibold text-primary">Note: Add new email template </span>',
            saveApi: 'mdcdot_email.save',
            payloadProcessor: 'aimi_mdcdot_sequencer.newEmailTemplatePayloadProcessor',
            saveApiCallBack: 'aimi_mdcdot_sequencer.newEmailTemplateSaveCallback'
          }).then(function ($modal) {
            app.newEmailModal = $modal;

            $modal.find('textarea[name=templateHtml]').on('keyup change', function () {
              const $this = $(this);
              $modal.find('textarea[name=templateText]').val(Utils.convertHtmlToText($this.val()));
            })

          });

          break;

        case 'show-edit-email-container' :
          const emailId = $this.attr('data-id');
          let email = {};
          if (!app.isEmpty(emailId)) {
            email = app.allEmails[emailId];
          }

          app.inputPrompt({
            data: email,
            modalId: "update-email",
            type: "input",
            formName: "update-email",
            modalDialogClass: "modal-xl modal-dialog-centered modal-dialog-scrollable modal-new-email",
            template: "dot_sequencer__dot-new-email",
            title: "Edit Email",
            saveButtonText: 'Update Email',
            footerText: '<span class="fw-semibold text-primary">Note: Update email template </span>',
            saveApi: 'mdcdot_email.save',
            payloadProcessor: 'aimi_mdcdot_sequencer.newEmailTemplatePayloadProcessor',
            saveApiCallBack: 'aimi_mdcdot_sequencer.newEmailTemplateSaveCallback'
          }).then(function ($modal) {
            app.newEmailModal = $modal;
            if (!app.isEmpty(email)) {

            }

            $modal.find('textarea[name=templateHtml]').on('keyup change', function () {
              const $this = $(this);
              $modal.find('textarea[name=templateText]').val(Utils.convertHtmlToText($this.val()));
            })

          });

          break;
        case "dot-delete":
          app.dotDeleteButton = $this;
          app.addNewActionButton = $this;
          // Confirms deletion of a sequence action
          app.confirm(
              "Confirm Delete",
              "Are you sure to delete this action? This will remove all the actions below this dot."
          ).then(async function (response) {
            const $button = response.button;
            const confirm = response.confirm;
            const $modal = response.modal;

            // If the user confirms the deletion, proceed with the delete operation.
            if (confirm === true) {
              addNewNode('end');
              app.doButtonAction($button);
              const requestData =  Sequencer.collectData();
              const saveResponse = await app.apis['mdcdot_sequence'].save(requestData);
              app.doButtonResetDelayed($button);
              app.hideModal($modal);
            }

          });
          break;

        case "end-delete":
          // Replaces a node-label wrapper with an end node
          const endNode = _.template(app.templates["dot_sequencer__end-action"])();
          const $parent = $this.closest(".node-label");
          $this.closest(".node-label-wrapper").hide();
          $parent.find('.add-action-container').remove();
          $(endNode).appendTo($parent);
          break;

        case "add-end":
          // Reveals the 'add end' node label
          const $nodeLabel = $this.closest(".node-label");
          $nodeLabel.find(".add-action-container").hide();
          $nodeLabel.find(".node-label-wrapper").show().removeClass('d-none');
          break;

        case "add-new-action":
          app.addNewActionButton = $this;
          if (!app.isEmpty(app.currentOpenDot)) {
            app.previousDot = app.clone(app.currentOpenDot);
          }

          app.currentOpenDot = null;
          // Displays a context menu for adding new actions
          Sequencer.removeContextMenu();
          const contextMenu = _.template(app.templates["dot_sequencer__dot-actions"])({
            actions: Sequencer.getActions()
          });

          const $buttonParent = $this.parent();

          $buttonParent.css({'position': 'relative'});

          const $contextMenu = $(contextMenu).appendTo($buttonParent);

          $contextMenu.css({
            top: `30px`,
            left: `50px`,
            width: '300px',
            display: "block",
            position: "absolute",
          });
          console.log(app.currentOpenDot);
          break;

        case "email-variants":
          app.currentOpenDot = {
            'dot': $this.closest('[data-dot]:not(.campaign-end)'),
            'data-id': $this.attr('data-id')
          };
          openEmailVariantsEditor();
          break;

        case 'add-branches' :
          Sequencer.removeContextMenu();
          addNewNode('QualifyNonQualify', {});
          break;
        case 'new' :
        case 'edit' :
          const editId = $this.attr('data-id');
          let sequence = {
            title: 'New Sequence',
            saveButtonText: 'Save Sequence',
            saveApi: 'mdcdot_campaign.save',
            mode: 'add'
          }

          let filterCampaignManager = false, filterGroup = false;

          if (!app.isEmpty(editId)) {
            sequence.title = 'Edit Sequence';
            sequence.saveButtonText = 'Update Sequence';
            sequence.saveApi = 'mdcdot_campaign.update';
            sequence.mode = 'edit';
            sequence.data = apiResponse.sequences[app.sequencerSequenceId];

            const dotGroupFilter = sequence.data.dotGroupFilter
            filterCampaignManager = dotGroupFilter.some(item => "CampaignManager" in item);
            filterGroup = dotGroupFilter.some(item => "Group" in item);
          } else {
            filterCampaignManager = true;
          }

          const switchQualifyCampaign = checkbox({
            'id': 'switchQualifyCampaign',
            'name': 'filters',
            'type': 'radio',
            'checked': filterCampaignManager ? 'checked' : false,
            'value': 'CampaignManager',
            'label': ` Campaign Manager(CRM) / Webform / API Call`
          });

          const switchQualifyDotGroup = checkbox({
            'id': 'switchQualifyDotGroup',
            'name': 'filters',
            'type': 'radio',
            'checked': filterGroup ? 'checked' : false,
            'value': 'Group',
            'label': `  Existing Dot Group`,
            'collapse': '#existingDotGroupCollapse'
          });

          app.inputPrompt({
            data: {
              ...sequence.data, ...{
                "switchQualifyCampaign": switchQualifyCampaign,
                "switchQualifyDotGroup": switchQualifyDotGroup,
              }
            },
            type: "input",
            mode: sequence.mode,
            modalDialogClass: "modal-lg modal-dialog-centered modal-dialog-scrollable modal-new-campaign",
            template: 'dot_campaign__new-sequence',
            title: sequence.title,
            saveButtonText: sequence.saveButtonText,
            footerText: '<span class="fw-semibold text-primary fs-8">Note: </span><span>change of qualifying options is not allowed once a campaign has been launched.</span>',
            saveApi: sequence.saveApi,
            payloadProcessor: 'aimi_mdcdot_sequencer.createPayloadProcessor',
            saveApiCallBack: 'aimi_mdcdot_sequencer.createCallBack'
          }).then(async function ($modal) {

            const dotGroups = await app.apis['mdcdot_campaign'].existingDotGroups(app.sequencerCampaignId);
            const $select = $modal.find('select[name="dotGroup"]');
            const emailsDropdown = new DropdownUtility($select);
            emailsDropdown.populateDropdown(_.values(dotGroups.dotGroups), "id", "name");

            const $switchFilter = $modal.find(':input[name=filters]');
            app.initRadioSwitches($modal);

            if (!app.isEmpty(editId)) {
              // Create the hidden input element
              const $hiddenInput = $('<input>', {
                type: 'hidden',
                name: 'sequenceId',
                value: editId
              });

              // Append the hidden input to the $modal body
              $modal.find('form').append($hiddenInput);

              if (filterGroup) {
                const options = $select.find('option');
                options.filter(`[value="${sequence.data.dotGroupId}"]`).prop('selected', true);

                // Ensure the event listener is properly attached and then trigger the change
                setTimeout(() => {
                  $switchFilter.trigger('click'); // Trigger the change event
                  $switchFilter.triggerHandler('change'); // Trigger the change event
                }, 100);
              }

            }
          });
          break;
        case 'edit-campaign':
          aimi_mdcdot_campaign.campaignSettingsModal(apiResponse.campaign, apiResponse.firstSequence);
          break;
        case 'trash-campaign':
          // Confirms deletion of a sequence action
          app.confirm(
              "Confirm Delete Campaign",
              "<div>Are you sure to delete this campaign? </div> <div> All sequences from this campaign will be removed and  all data will be lost </div>"
          ).then(async function (response) {
            const $button = response.button;
            const confirm = response.confirm;
            const $modal = response.modal;

            // If the user confirms the deletion, proceed with the delete operation.
            if (confirm === true) {
              app.doButtonAction($button);
              const response = await app.apis.mdcdot_campaign.delete({campaignId: app.sequencerCampaignId});
              app.doButtonResetDelayed($button);
              app.hideModal($modal);

              app.redirect(`/email-campaigns`);
            }
          });
          break;
        case 'trash' :
          // Confirms deletion of a sequence action
          app.confirm(
              "Confirm Delete Sequence",
              "<div>Are you sure to delete this sequence? </div> <div> Your sequence will be removed and all data will be lost </div>"
          ).then(async function (response) {
            const $button = response.button;
            const confirm = response.confirm;
            const $modal = response.modal;

            // If the user confirms the deletion, proceed with the delete operation.
            if (confirm === true) {
              app.doButtonAction($button);
              const response = await app.apis.mdcdot_campaign.delete({
                campaignId: app.sequencerCampaignId,
                sequenceId: app.sequencerSequenceId
              });
              app.doButtonResetDelayed($button);
              app.hideModal($modal);

              app.redirect(`/email/campaign/${app.sequencerCampaignId}/${response.sequence.id}`);
            }
          });
          break;

        case 'dot-stats' :
          openEmailVariantsTable($this);
          break;

        case 'test':
          // Handles the email preview modal
          const sequenceId = $this.attr("data-id");
          // Open a modal for campaign leads

          console.log(JSON.stringify(app.currentSequence.qualifyingParams));

          const $testModal = app.infoModal(`Test Sequence #${sequenceId} `, '', {
            id: 'testSequenceModal',
            dialogClass: ' fullscreen-right modal-md modal-test-sequence-modal modal-dialog-scrollable',
            saveButton: true,
            saveButtonText: 'Create test lead and start test',
            footerText: '',
          });

          app.$dotSequencerTestModal = $testModal;

          const $testModalModal = $('.modal-body', $testModal);

          // Render the leads template
          const test = _.template(app.templates['dot_sequencer__test']);

          let actions = [
            {"text": "Leads Added", "key": "LeadsAdded"},
            {"text": "Added to Sequence", "key": "AddedToSequence"}
          ];

          _.each(app.currentSequence.defaultActions, function (row) {
            // Extract key and value for each object in the array
            _.each(row, (defaultAction, defaultActionKey) => {
              const action = {
                key: `${defaultActionKey}-${defaultAction.id}`,
                action: defaultAction,
                text: `${defaultActionKey} ${defaultAction.id} Delay : ${defaultAction.delay}`
              };
              actions.push(action);

            });

          });

          if (!app.isEmpty(app.currentSequence.qualifyingParams)) {
            const qualifyingParams = app.currentSequence.qualifyingParams.flatMap(item => {
              const key = Object.keys(item).find(k => Array.isArray(item[k])); // Ensure key points to an array
              console.log(key, item);
              if (!key) return []; // Skip if no valid key is found
              return item[key].map(v => `${v.activity}: ${v.delay || v.expires}`);
            }).join(", ");


            _.each(app.currentSequence.qualifierActions, function (row) {
              // Extract key and value for each object in the array
              _.each(row, (defaultAction, defaultActionKey) => {
                const action = {
                  key: `${defaultActionKey}-${defaultAction.id}`,
                  action: defaultAction,
                  text: `${qualifyingParams} ${defaultActionKey} ${defaultAction.id} Delay : ${defaultAction.delay}`
                };
                actions.push(action);

              });

            });
          }


          if (!app.isEmpty(app.currentSequence.nonQualifyingParams)) {

            const nonQualifyingParams = app.currentSequence.nonQualifyingParams.flatMap(item => {
              const key = Object.keys(item).find(k => Array.isArray(item[k])); // Ensure key points to an array
              console.log(key, item);
              if (!key) return []; // Skip if no valid key is found
              return item[key].map(v => `${v.activity}: ${v.delay || v.expires}`);
            }).join(", ");

            _.each(app.currentSequence.nonQualifierActions, function (row) {
              // Extract key and value for each object in the array
              _.each(row, (defaultAction, defaultActionKey) => {
                const action = {
                  key: `${defaultActionKey}-${defaultAction.id}`,
                  action: defaultAction,
                  text: `${nonQualifyingParams} ${defaultActionKey} ${defaultAction.id} Delay : ${defaultAction.delay}`
                };
                actions.push(action);

              });

            });
          }


          app.dotSequencerTestActions = actions;

          let actionsHtml = SequencerTest.addTestActions(actions);

          const $test = $(test({actions: actionsHtml, 'email': Utils.generateEmail('ShankaranPatel', "gmail.com")}));
          $test.appendTo($testModalModal);

          $testModal.promise.then(async function (response) {
            const $modal = response.modal;
            const $button = response.button;
            if (response.confirm) {
              app.doButtonAction($button);
              const email = $modal.find(":input[name=email]").val();
              const leadAddedResponse = await SequencerTest.addTestLead(email);

              app.doButtonResetDelayed($button);
              $button.closest('.btn-save-button').hide();

              if (leadAddedResponse.success) {
                $modal.find('[data-add-test-lead-form]').addClass('d-none');
                $modal.find('[data-test-checklist]').removeClass('d-none');
                SequencerTest.moveToNextAction($modal, actions[0].key, actions[1].key, ` => Id : ${leadAddedResponse.leadResponse.id}`);

                SequencerTest.scrollSequencerTo($(`[data-dot="Group-${app.currentSequence.dotGroupId}"]`));
                const sequenceResponse = await SequencerTest.addToSequence(email, app.currentSequence);

                if (sequenceResponse.success) {
                  SequencerTest.moveToNextAction($modal, actions[1].key, actions[2].key, ` => DotGroup : ${app.currentSequence.dotGroupId}`);
                  const nextActionKey = actions[2].key;
                  SequencerTest.scrollSequencerTo($(`[data-dot="${nextActionKey}"]:not([data-activities])`));

                  app.dotSequencerTestActionsStep = 2;
                  // Usage Example
                  const pinger = new LeadActivityPinger(leadAddedResponse.leadResponse.id, 'dot_action_queues', 5000, 1000);
                }
              }
            }
          })
          break;

        default:
          console.warn(`Unhandled action: ${action}`);
      }
    });

    const apiResponse = await app.apis.mdcdot.campaign.sequences(campaignId);
    // Get all emails data
    app.allEmails = apiResponse.emails;

    await aimi_email_variants.view.renderExistingCampaigns(true, false);

    $sequenceActions.removeClass('d-none');

    if (app.isEmpty(sequenceId)) {
      container.empty();
      let $lastSequencer = null;
      let previousSequencers = [];
      _.each(apiResponse.sequences, function (sequence) {
        const $sequencer = container.sequenceTree(sequence.sequencer, false, false, sequence);
        previousSequencers.push($sequencer);
        console.log(previousSequencers.slice());

        const firstNode = $sequencer.find('ul').eq(1);
        const firstNodeIdentifier = $.trim(firstNode.find('[data-dot]').eq(0).attr('data-dot'));

        if (app.isEmpty($lastSequencer)) {
          $sequencer.appendTo(container);
        } else {
          let hasAttachment;

          _.find(previousSequencers.reverse(), function (lastSequencer) {
            const $currentSequencer = $(lastSequencer);

            // Find the closest <li> parent of the last `.campaign-end` within the current sequencer
            const lastDotParent = $currentSequencer.children('ul').last();

            // Check for the element with `data-dot` equal to `firstNodeIdentifier` within `lastDotParent`
            const foundAttachment = lastDotParent.find(`[data-dot="${firstNodeIdentifier}"]`).last();

            // Return true if `foundAttachment` exists, which stops the loop and sets `hasAttachment`
            if (foundAttachment.length) {
              hasAttachment = foundAttachment;
              return true;
            }
          });

          // If `hasAttachment` exists, append `$sequencer` to the `li` parent of `hasAttachment`
          if (hasAttachment && hasAttachment.length) {
            const li = hasAttachment.closest('li');
            $sequencer.appendTo(li);
          } else {
            $sequencer.appendTo(container);
          }
        }

        $lastSequencer = $sequencer;
      });
      Sequencer.removeDeleteActions(container);
    } else {
      app.currentSequence = apiResponse.sequences[sequenceId];
      const $sequenceTree = container.sequenceTree(app.currentSequence.sequencer, true, true, app.currentSequence);
      Sequencer.addEndActions($sequenceTree);
    }

    const renderDotGroupDropdown = async function ($modal) {
      const dotGroups = await app.apis['mdcdot_campaign'].dotGroups();
      app.allDotGroups = dotGroups.dotGroups;
      const $select = $modal.find('select[name="Group"]');
      const emailsDropdown = new DropdownUtility($select);
      emailsDropdown.populateDropdown(_.values(dotGroups.dotGroups), "id", "name");
      return $select;
    }


  };

  class SequencerTest {
    static testActionRow() {
      // Define the template as a string
      let sequenceAction = `
                   <div class="mt-2 text-left <%=paddingLeft %>" data-test-action-message="<%= message.text %>" data-test-action-key="<%= message.key %>">
                       <i class="fa-light fa-hourglass-clock"></i>  <span data-test-action-status class="fw-semibold">Pending</span> <%= message.text %> <span data-test-action-result></span>
                    </div>
                  `;

      // Compile the template
      let compiledSequenceAction = _.template(sequenceAction);

      return compiledSequenceAction;
    }

    static addTestActions(actions, paddingLeft = '') {
      const actionsHtml = [];
      const testActionRow = this.testActionRow();
      for (let i = 0; i < actions.length; i++) {
        actionsHtml.push(testActionRow({
          'paddingLeft': paddingLeft,
          'message': actions[i]
        }));
      }
      return actionsHtml;
    }

    static getParentActionKey($modal, key) {
      return this.getParentAction($modal, key).attr('data-test-action-key');
    }

    static getParentAction($modal, key) {
      const currentAction = $modal.find(`[data-test-action-key="${key}"]`);
      const $parent = currentAction.parent();
      return $parent;
    }

    static getParentNextActionKey($modal, key) {
      return this.getParentAction($modal, key).next().attr('data-test-action-key');
    }

    static moveToNextAction($modal, key, nextKey, currentActionIndexResponse) {
      const currentActionText = key;
      const currentAction = $modal.find(`[data-test-action-key="${currentActionText}"]`);
      currentAction.addClass('text-success');
      currentAction.removeClass('text-primary');
      currentAction.find('i').addClass('fa-check');
      currentAction.find(`[data-test-action-status]`).html('Done');
      currentAction.attr('data-action-status', 'done');
      if (currentActionIndexResponse) {
        currentAction.find(`[data-test-action-result]`).html(currentActionIndexResponse);
      }


      if (nextKey) {
        const nextActionText = nextKey;
        const nextAction = $modal.find(`[data-test-action-key="${nextActionText}"]`);
        nextAction.addClass('text-primary');
        nextAction.attr('data-action-status', 'in-progress');
        nextAction.find(`[data-test-action-status]`).html('In Progress');
        nextAction.find('i').addClass('fa-spinner animated infinite fadeIn');
      }
    }

    static async addTestLead(email) {
      const leadAddedResponse = await app.apis['dot_instance_apis'].lead.add(this.getLeadRequestData(email));
      return leadAddedResponse;
    }

    static async addToSequence(email, sequence) {
      const {firstName, lastName} = Utils.extractName(email);
      const requestData = {...this.getLeadRequestData(email), ...{campaign: sequence.dotGroupId}};
      const response = await app.apis['dot_instance_apis'].lead.add(requestData);
      return response;
    }

    static getLeadRequestData(email) {
      const {firstName, lastName} = Utils.extractName(email);
      email = email.toLowerCase();
      return {
        email: email,
        userId: 1,
        firstName: firstName,
        lastName: lastName,
        mobilePhone: ''
      };
    }

    static scrollSequencerTo(childSelector = null) {
      $('.sequence-tree').find('.animated').removeClass('animated flash infinite');

      if (childSelector) {
        const $child = $(childSelector);
        $child.addClass('animated flash infinite');
        const child = $child[0];
        if (child) {
          child.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } else {
          console.log('Child not found');
        }
      }

    }
  }

  class LeadActivityPinger {
    constructor(leadId, action, inactivityTimeout = 300000, pingInterval = 1000) {
      this.leadId = leadId;
      this.action = action,
          this.inactivityTimeout = inactivityTimeout;
      this.pingInterval = pingInterval;

      this.isUserActive = true;
      this.isRequestInProgress = false;
      this.inactivityTimer = null;
      this.isPinging = true; // Flag to control pinging

      this.init();
    }

    init() {
      // Bind user activity detection
      ['mousemove', 'keydown', 'click'].forEach(event => {
        document.addEventListener(event, () => this.setUserActive());
      });

      // Start the ping loop
      this.startPinging();
    }

    setUserActive() {
      this.isUserActive = true;

      // Reset the inactivity timer
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = setTimeout(() => {
        this.isUserActive = false;
      }, this.inactivityTimeout);
    }

    async pingServer() {
      const self = this;
      console.log(this.isUserActive);

      // !this.isUserActive ||
      if (this.isRequestInProgress) return;
      this.isRequestInProgress = true;

      try {
        const response = await app.apis['mdcdot_sequence'].leadActivityTree(this.leadId, app.currentSequence.id, this.action)
        if (!app.isEmpty(response.dot_action_queues)) {
          if (!app.isEmpty(response.dot_action_queues[app.currentSequence.id])) {
            const dotActionQueues = response.dot_action_queues[app.currentSequence.id];
            const updateResponse = await app.apis['mdcdot_sequence'].updateDotActionQueueExecutionToPastForTesting(this.leadId, app.currentSequence.id)
            _.each(dotActionQueues, function (dotActionQueue) {
              const key = `${dotActionQueue.foreignType}-${dotActionQueue.foreignId}`;
              const $currentTestAction = $(`[data-test-action-key=${key}]`);
              let actions = [];
              if (dotActionQueue.foreignType === 'SendVariant' && !$currentTestAction.is('[data-children]')) {

                let action = {'text': `Added Email to Actions Queue`, 'key': `DotActionQueue-${dotActionQueue.id}`};
                actions.push(action);

                action = {'text': `Email Variant Sent`, 'key': `EmailVariantSent-${dotActionQueue.emailVariantId}`};
                actions.push(action);

                action = {
                  'text': `Email Variant Delivered`,
                  'key': `EmailVariantDelivered-${dotActionQueue.emailVariantId}`
                };
                actions.push(action);

                action = {'text': `Email Variant Opened`, 'key': `EmailVariantOpened-${dotActionQueue.emailVariantId}`};
                actions.push(action);

                const actionRows = SequencerTest.addTestActions(actions, 'ps-4');
                $(actionRows.join('')).appendTo($currentTestAction);
                $currentTestAction.attr('data-children', true);

                SequencerTest.moveToNextAction(app.$dotSequencerTestModal, actions[0].key, actions[1].key, ` => Id : ${dotActionQueue.id}`);
                self.action = "email_variants_sent";
              }
              if (dotActionQueue.foreignType === 'SendEmail' && !$currentTestAction.is('[data-children]')) {

                let action = {'text': `Added Email to Actions Queue`, 'key': `DotActionQueue-${dotActionQueue.id}`};
                actions.push(action);

                action = {'text': `Email  Sent`, 'key': `EmailSent-${dotActionQueue.emailId}`};
                actions.push(action);

                action = {'text': `Email  Delivered`, 'key': `EmailDelivered-${dotActionQueue.emailId}`};
                actions.push(action);

                action = {'text': `Email  Opened`, 'key': `EmailOpened-${dotActionQueue.emailId}`};
                actions.push(action);

                const actionRows = SequencerTest.addTestActions(actions, 'ps-4');
                $(actionRows.join('')).appendTo($currentTestAction);
                $currentTestAction.attr('data-children', true);

                SequencerTest.moveToNextAction(app.$dotSequencerTestModal, actions[0].key, actions[1].key, ` => Id : ${dotActionQueue.id}`);
                self.action = "emails_sent";
              }
              if (dotActionQueue.foreignType === 'Group' && !$currentTestAction.is('[data-children]')) {

                let action = {'text': `Added Email to Actions Queue`, 'key': `DotActionQueue-${dotActionQueue.id}`};
                actions.push(action);

                action = {'text': `Added to Group`, 'key': `AddedToDotGroup-${dotActionQueue.foreignId}`};
                actions.push(action);

                const actionRows = SequencerTest.addTestActions(actions, 'ps-4');
                $(actionRows.join('')).appendTo($currentTestAction);
                $currentTestAction.attr('data-children', true);

                SequencerTest.moveToNextAction(app.$dotSequencerTestModal, actions[0].key, actions[1].key, ` => Id : ${dotActionQueue.id}`);
              }
            });
          }
        }

        if (!app.isEmpty(response.email_variants_sent)) {
          if (!app.isEmpty(response.email_variants_sent[app.currentSequence.id])) {
            const emailVariantsSent = response.email_variants_sent[app.currentSequence.id];
            console.log(emailVariantsSent);
            _.each(emailVariantsSent, function (emailVariantSent) {
              SequencerTest.moveToNextAction(app.$dotSequencerTestModal, `EmailVariantSent-${emailVariantSent.emailVariantId}`, `EmailVariantDelivered-${emailVariantSent.emailVariantId}`, ` => Id : ${emailVariantSent.id}`);
              self.action = "activities";
            });
          }
        }

        if (!app.isEmpty(response.emails_sent)) {
          if (!app.isEmpty(response.emails_sent[app.currentSequence.id])) {
            const emailsSent = response.emails_sent[app.currentSequence.id];
            _.each(emailsSent, function (emailSent) {
              SequencerTest.moveToNextAction(app.$dotSequencerTestModal, `EmailSent-${emailSent.emailId}`, `EmailDelivered-${emailSent.emailId}`, ` => Id : ${emailSent.id}`);
              self.action = "activities";
            });
          }
        }

        if (!app.isEmpty(response.activities)) {
          if (!app.isEmpty(response.activities[app.currentSequence.id])) {
            const activities = response.activities[app.currentSequence.id];
            _.each(activities, function (activity) {
              if (activity.activity === 'email_variant') {
                if (activity.type === 'open') {
                  SequencerTest.moveToNextAction(app.$dotSequencerTestModal, `EmailVariantOpened-${activity.emailVariantId}`, null, ` => Id : ${activity.id}`);
                  const parentActionKey = SequencerTest.getParentActionKey(app.$dotSequencerTestModal, `EmailVariantOpened-${activity.emailVariantId}`);
                  const parentNextActionKey = SequencerTest.getParentNextActionKey(app.$dotSequencerTestModal, `EmailVariantOpened-${activity.emailVariantId}`);
                  SequencerTest.moveToNextAction(app.$dotSequencerTestModal, parentActionKey, parentNextActionKey, null);
                  SequencerTest.scrollSequencerTo($(`[data-dot="${parentNextActionKey}"]:not([data-activities])`));

                } else if (activity.type === 'delivered') {
                  SequencerTest.moveToNextAction(app.$dotSequencerTestModal, `EmailVariantDelivered-${activity.emailVariantId}`, `EmailVariantOpened-${activity.emailVariantId}`, ` => Id : ${activity.id}`);
                }

                if (self.action !== 'dot_group_leads') {
                  self.action = "activities";
                }
              }

              if (activity.activity === 'email') {
                if (activity.type === 'open') {
                  SequencerTest.moveToNextAction(app.$dotSequencerTestModal, `EmailOpened-${activity.emailId}`, null, ` => Id : ${activity.id}`);
                  const parentActionKey = SequencerTest.getParentActionKey(app.$dotSequencerTestModal, `EmailOpened-${activity.emailId}`);
                  const parentNextActionKey = SequencerTest.getParentNextActionKey(app.$dotSequencerTestModal, `EmailOpened-${activity.emailId}`);
                  SequencerTest.moveToNextAction(app.$dotSequencerTestModal, parentActionKey, parentNextActionKey, null);
                  SequencerTest.scrollSequencerTo($(`[data-dot="${parentNextActionKey}"]:not([data-activities])`));

                } else if (activity.type === 'delivered') {
                  SequencerTest.moveToNextAction(app.$dotSequencerTestModal, `EmailDelivered-${activity.emailId}`, `EmailOpened-${activity.emailId}`, ` => Id : ${activity.id}`);
                }

                if (self.action !== 'dot_group_leads') {
                  self.action = "activities";
                }
              }

            });
          }
        }

        if (!app.isEmpty(response.dot_group_leads)) {
          const dotGroupLeads = response.dot_group_leads;
          _.each(dotGroupLeads, function (dotGroupLead) {
            SequencerTest.moveToNextAction(app.$dotSequencerTestModal, `AddedToDotGroup-${dotGroupLead.dotGroupId}`, null, ` => Id : ${dotGroupLead.id}`);
            SequencerTest.moveToNextAction(app.$dotSequencerTestModal, `Group-${dotGroupLead.dotGroupId}`, null,);
          });


        }

        if (app.$dotSequencerTestModal.find(`[data-action-status="in-progress"]`).length === 0) {
          self.stopPinging();
          SequencerTest.scrollSequencerTo();
        }

      } catch (error) {
        console.error('Ping failed:', error);
      } finally {
        this.isRequestInProgress = false;
      }
    }

    startPinging() {
      const pingLoop = async () => {
        if (!this.isPinging) return; // Stop the loop if pinging is disabled
        await this.pingServer();
        setTimeout(pingLoop, this.pingInterval);
      };

      pingLoop();
    }

    stopPinging() {
      this.isPinging = false; // Disable pinging
      clearTimeout(this.inactivityTimer); // Clear inactivity timer if necessary
      console.log('Pinging stopped.');
    }
  }


}(window.aimi_mdcdot_sequencer = window.aimi_mdcdot_sequencer || {}, jQuery, PreBuilt));


